import * as React from 'react';
import { IconProps } from '../types';

const IcTime = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={props?.fill ?? '#232F3E'}
      d="M12.5 23a11 11 0 1 1 0-22 11 11 0 0 1 0 22Zm0-20.429a9.429 9.429 0 1 0 0 18.858 9.429 9.429 0 0 0 0-18.858Z"
    />
    <path
      fill={props?.fill ?? '#232F3E'}
      d="m16.106 16.714-4.392-4.392V4.93h1.572v6.741l3.928 3.936-1.108 1.108Z"
    />
  </svg>
);

export default IcTime;
